import AddCircleGrey from "../../assets/icons/add-circle-grey.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import "./CreateActionTile.less";

export type CreateActionTileProps = {
  labelKey: string;
  onClick?: () => void;
  iconSrc?: string;
  alt?: string;
  className?: string;
};

const CreateActionTile: React.FC<CreateActionTileProps> = ({ labelKey, onClick, iconSrc, alt = "add", className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`create-action-tile ${className || ""}`.trim()}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <img src={iconSrc || AddCircleGrey} alt={alt} />
      <p className="create-action-text">{t(labelKey)}</p>
    </div>
  );
};

export default CreateActionTile;
